const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="demo-u-size-block">
  <div style="height:150px;">
    <div class="u-size-block-full u-pad-n1 u-rounded t-dark t-alternate u-text-center">
      full (in a 150px tall container)
    </div>
  </div>
  <div style="height:150px;" class="t-alternate">
    <div class="u-size-block-auto u-pad-n1 u-rounded t-dark t-alternate u-text-center">
      auto (in a 150px tall container)
    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `4610883f5cbf7280780b72a022c315a7b3ec47c1180889054ad3c89e26b5af14`;
            }

            getSourceContext() {
                return new this.Source(``, `4610883f5cbf7280780b72a022c315a7b3ec47c1180889054ad3c89e26b5af14`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '4610883f5cbf7280780b72a022c315a7b3ec47c1180889054ad3c89e26b5af14');

let template = env.loadTemplate('4610883f5cbf7280780b72a022c315a7b3ec47c1180889054ad3c89e26b5af14');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/size/demo/block-size.twig", args: context }
     );
     return rendered;;
};